import React, { useRef, useEffect } from 'react';
import './Events.css';

const Events = () => {
  
  const heroRef = useRef(null);
  
  useEffect(() => {
    
    if (heroRef.current) {
      setTimeout(() => {
        heroRef.current.style.opacity = "1";
        heroRef.current.style.transform = "translateY(0)";
      }, 300);
    }
    
    
    const eventBoxes = document.querySelectorAll('.event-box');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, { threshold: 0.1 });
    
    eventBoxes.forEach(box => {
      observer.observe(box);
    });
    
    return () => {
      eventBoxes.forEach(box => {
        observer.unobserve(box);
      });
    };
  }, []);

  return (
    <div className="events-container">
      <section 
        className="events-hero"
        ref={heroRef}
        style={{ opacity: "0", transform: "translateY(-20px)", transition: "all 1s ease" }}
      >
        <h1>Events</h1>
        <p>Join us for fellowship, worship, and spiritual growth</p>
      </section>

      <h2>Our Regular Events</h2>
      <div className="event-boxes">
        <div className="event-box fade">
          <img src="/bible-study.jpeg" alt="Bible Study" />
          <h3>Bible Study</h3>
          <p>Every Tuesday at 8:30 PM</p>
          <p>Bible study is lead by Pastor Finney Mathew. Get in touch with us to know more about the Bible study sessions.</p>
        </div>

        <div className="event-box fade">
          <img src="/fasting-prayer.jpeg" alt="Fasting Prayer" />
          <h3>Evening Prayer</h3>
          <p>Every Friday or Saturday at 8:00 PM</p>
          <p>Fasting prayer will be held every Friday or Saturday from 8:00 PM. Fill the form to know more about the fasting prayers.</p>
        </div>

        <div className="event-box fade">
          <img src="/mission-sundays.jpeg" alt="Mission Sunday" />
          <h3>Mission Sunday</h3>
          <p>Every first Sunday of the month</p>
          <p>First Sunday of the month is dedicated to mission work. We will have a seminar looking at influential missionaries and their stories.</p>
        </div>
      </div>

      <h2>Special Events</h2>
      <div className="event-boxes">
        <div className="event-box fade">
          <img src="/church-placeholder.jpeg" alt="Fasting Prayer" className="placeholder-image" />
          <h3>Fasting Prayer</h3>
          <p className="event-date">Friday, May 30th from 10:00AM to 10:00PM</p>
          <p>We invite you to participate in our daylong fasting and prayer, beginning at 10:00 AM. Please fill in the form if you are interested in joining us.</p>
        </div>

        <div className="event-box fade">
          <img src="/church-placeholder.jpeg" alt="Children's VBS" className="placeholder-image" />
          <h3>Children's VBS</h3>
          <p className="event-date">Saturday, May 31st at 8:30AM to 2:00PM</p>
          <p>A fun and engaging event for children to learn about Jesus and His love. We invite all children aged 4-18 to join us for this special day.</p>
        </div>

        <div className="event-box fade">
          <img src="/church-placeholder.jpeg" alt="Revival Meeting" className="placeholder-image" />
          <h3>Revival Meeting</h3>
          <p className="event-date">Saturday, May 31st from 5PM to 10PM</p>
          <p>Revival meeting will be lead by guest Pastor Gladson Varghese who will be ministering to us at Faith Tabernacle Church.</p>
        </div>
      </div>
    </div>
  );
};

export default Events;
